import { EntityRoutes } from 'routes/constants';
import strings from 'strings';
import { DateFormats, defaultProfileColumnsConfig } from 'UI/constants/defaults';
import { KEYWORDS_COLUMN } from 'UI/constants/sharedColumns';

export const HiringAuthorityProfileJobOrderColumns = [
  {
    name: 'id',
    options: {
      display: 'excluded'
    }
  },
  {
    name: 'title',
    label: 'Title',
    options: {
      display: true,
      sort: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.JobOrderProfile,
          idKey: 'id',
          textKey: 'title'
        }
      }
    }
  },
  {
    name: 'companyName',
    label: 'Company',
    options: {
      display: true,
      sort: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.CompanyProfile,
          idKey: 'id',
          textKey: 'name'
        }
      }
    }
  },
  {
    name: 'position',
    label: strings.shared.fields.jobFunction,
    options: {
      ...defaultProfileColumnsConfig,
      renderer: {
        id: 'custom',
        config: {
          customValue: 'title'
        }
      }
    }
  },
  {
    name: 'specialty.industry.title',
    label: 'Industry',
    options: {
      ...defaultProfileColumnsConfig,
      renderer: 'default'
    }
  },
  {
    name: 'specialty.title',
    label: 'Specialty',
    options: {
      ...defaultProfileColumnsConfig,
      renderer: 'default'
    }
  },
  {
    name: 'compensation',
    label: 'Compensation Range',
    options: {
      ...defaultProfileColumnsConfig,
      renderer: 'compensationRange'
    }
  },
  {
    name: 'address',
    label: 'Location',
    options: {
      ...defaultProfileColumnsConfig,
      renderer: 'location'
    }
  },
  {
    name: 'createdAt',
    label: 'Creation Date',
    options: {
      sort: true,
      renderer: 'date'
    }
  },
  {
    name: 'statusTitle',
    label: 'Status',
    options: {
      display: false,
      sort: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          labelKey: 'title',
          baseClass: 'chip-candidate-status',
          variant: 'outlined'
        }
      }
    }
  },
  {
    name: 'jobOrderTypeTitle',
    label: 'Type',
    options: {
      display: false,
      sort: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          baseClass: 'chip-candidate-type',
          labelKey: 'title'
        }
      }
    }
  },
  {
    name: 'lastActivityDate',
    label: 'Last Activity on',
    options: {
      display: false,
      sort: true,
      renderer: {
        id: 'dateBuilder',
        config: {
          format: DateFormats.SimpleDateTime
        }
      }
    }
  },
  {
    name: 'recruiterName',
    label: 'Recruiter',
    options: {
      sort: true,
      display: false,
      renderer: 'default'
    }
  },
  {
    name: 'lastActivityLog.by',
    label: 'Last Activity by',
    options: {
      display: false,
      sort: false,
      renderer: 'default'
    }
  },
  {
    name: 'lastActivityLog.title',
    label: 'Last Activity',
    options: {
      display: false,
      sort: false,
      renderer: 'default'
    }
  },
  KEYWORDS_COLUMN
];

export const VirtualProps = [
  {
    propName: 'title',
    attributes: ['title', 'id']
  }
];
